var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as _ from 'lodash';
import * as query from 'query-string';
var MediaCriteria = /** @class */ (function () {
    function MediaCriteria(sort, filters) {
        if (sort === void 0) { sort = 'date'; }
        if (filters === void 0) { filters = []; }
        this.sort = sort;
        this.filters = filters;
    }
    return MediaCriteria;
}());
export { MediaCriteria };
var MediaFilterIn = /** @class */ (function () {
    function MediaFilterIn(field, values) {
        this.field = field;
        this.values = values;
        this.operation = 'in';
    }
    return MediaFilterIn;
}());
export { MediaFilterIn };
var MediaFilterBetween = /** @class */ (function () {
    function MediaFilterBetween(field, min, max) {
        this.field = field;
        this.min = min;
        this.max = max;
        this.operation = 'between';
    }
    return MediaFilterBetween;
}());
export { MediaFilterBetween };
var MediaFilterEquals = /** @class */ (function () {
    function MediaFilterEquals(field, value) {
        this.field = field;
        this.value = value;
        this.operation = 'equals';
    }
    return MediaFilterEquals;
}());
export { MediaFilterEquals };
var MediaFilterRanges = /** @class */ (function () {
    function MediaFilterRanges(field, ranges) {
        this.field = field;
        this.ranges = ranges;
        this.operation = 'ranges';
    }
    return MediaFilterRanges;
}());
export { MediaFilterRanges };
var TCMediaManager = /** @class */ (function () {
    function TCMediaManager() {
        this.internalPageSize = 100;
        this.baseURL = '';
        this.monthCounts = null;
        this.mediaOrder = null;
        this.mediaCache = {};
        this.requestPromiseCache = {};
        this.criteria = new MediaCriteria();
        this.tagCache = [];
        this.cameraCache = [];
        this.headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
    }
    TCMediaManager.prototype.refreshCache = function () {
        return __awaiter(this, void 0, void 0, function () {
            var count;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.mediaOrder = null;
                        return [4 /*yield*/, this.getTotalMediaCount()];
                    case 1:
                        count = _a.sent();
                        return [2 /*return*/, count];
                }
            });
        });
    };
    Object.defineProperty(TCMediaManager.prototype, "criteria", {
        get: function () {
            return this._criteria;
        },
        set: function (criteria) {
            this._criteria = criteria;
            this.mediaOrder = null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TCMediaManager.prototype, "authToken", {
        set: function (token) {
            this.headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            };
        },
        enumerable: true,
        configurable: true
    });
    TCMediaManager.prototype.getTotalMediaCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.mediaOrder != null) {
                            return [2 /*return*/, this.mediaOrder.length];
                        }
                        return [4 /*yield*/, this.fetchMediaCount()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.mediaOrder.length];
                }
            });
        });
    };
    TCMediaManager.prototype.getThumbnail = function (index) {
        if (this.mediaOrder == null) {
            throw new Error('Cache is null must be initialized');
        }
        if (index in this.mediaOrder) {
            var mediaID = this.mediaOrder[index];
            if (mediaID in this.mediaCache) {
                return this.mediaCache[mediaID];
            }
        }
        return null;
    };
    TCMediaManager.prototype.getThumbnailById = function (mediaID) {
        if (this.mediaCache == null) {
            throw new Error('Cache is null must be initialized');
        }
        if (mediaID in this.mediaCache) {
            return this.mediaCache[mediaID];
        }
        return null;
    };
    TCMediaManager.prototype.alreadyFetching = function (indexStart) {
        // Find page containing indexStart
        var pageSize = this.internalPageSize;
        var page = Math.floor(indexStart / pageSize);
        if (page in this.requestPromiseCache) {
            return true;
        }
        return false;
    };
    TCMediaManager.prototype.getFullsize = function (mediaID, skipCache) {
        return __awaiter(this, void 0, void 0, function () {
            var cachedMedia, response, media, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!skipCache) {
                            // Check if full size cached
                            if (this.mediaCache != null && mediaID in this.mediaCache) {
                                cachedMedia = this.mediaCache[mediaID];
                                if (cachedMedia.fullSizeUploaded && cachedMedia.fullSizeServerURL != null) {
                                    return [2 /*return*/, cachedMedia];
                                }
                            }
                        }
                        return [4 /*yield*/, fetch(this.baseURL + '/api/Media/FullMedia/' + mediaID, {
                                credentials: 'same-origin',
                                headers: this.headers,
                            })];
                    case 1:
                        response = _c.sent();
                        if (!response.ok)
                            throw response;
                        _b = (_a = JSON).parse;
                        return [4 /*yield*/, response.text()];
                    case 2:
                        media = _b.apply(_a, [_c.sent()]);
                        if (mediaID in this.mediaCache) {
                            _.assign(this.mediaCache[mediaID], media);
                        }
                        else {
                            this.mediaCache[mediaID] = media;
                        }
                        return [2 /*return*/, media];
                }
            });
        });
    };
    TCMediaManager.prototype.rateMedia = function (mediaID, rating) {
        return __awaiter(this, void 0, void 0, function () {
            var changeMedia, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        changeMedia = null;
                        if (rating < 0 || rating > 5) {
                            return [2 /*return*/, false];
                        }
                        if (mediaID in this.mediaCache) {
                            changeMedia = this.mediaCache[mediaID];
                            if (changeMedia.rating == rating) {
                                return [2 /*return*/, true];
                            }
                        }
                        return [4 /*yield*/, fetch(this.baseURL + '/api/Media/rate?mediaID=' + mediaID + '&rating=' + rating, {
                                method: 'POST',
                                credentials: 'same-origin',
                                headers: this.headers
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok)
                            throw response;
                        if (response.ok) {
                            if (changeMedia) {
                                changeMedia.rating = rating;
                            }
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    TCMediaManager.prototype.retainMedia = function (mediaIDs, retain) {
        return __awaiter(this, void 0, void 0, function () {
            var ids, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof (mediaIDs) != 'object')
                            mediaIDs = [mediaIDs];
                        ids = [];
                        mediaIDs.forEach(function (id) {
                            if (id in _this.mediaCache) {
                                if (_this.mediaCache[id].retain != retain)
                                    ids.push(id);
                            }
                        });
                        return [4 /*yield*/, fetch(this.baseURL + "/api/Media/retain?retain=" + +retain, {
                                method: 'POST',
                                credentials: 'same-origin',
                                headers: this.headers,
                                body: JSON.stringify(mediaIDs)
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok)
                            throw response;
                        if (response.ok) {
                            ids.forEach(function (id) { return _this.mediaCache[id].retain = retain; });
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    TCMediaManager.prototype.tagMedia = function (mediaID, tagName) {
        return __awaiter(this, void 0, void 0, function () {
            var mediaIDString, tagString, response, result, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        mediaIDString = encodeURI('' + mediaID);
                        tagString = encodeURI(tagName);
                        return [4 /*yield*/, fetch(this.baseURL + '/api/Media/Tag?mediaID=' + mediaIDString + '&tagName=' + tagString, {
                                method: 'POST',
                                credentials: 'same-origin',
                                headers: this.headers
                            })];
                    case 1:
                        response = _c.sent();
                        if (!response.ok)
                            throw response;
                        _b = (_a = JSON).parse;
                        return [4 /*yield*/, response.text()];
                    case 2:
                        result = _b.apply(_a, [_c.sent()]);
                        return [2 /*return*/, result.tagID];
                }
            });
        });
    };
    TCMediaManager.prototype.removeTag = function (mediaID, tagID) {
        return __awaiter(this, void 0, void 0, function () {
            var response, media;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(this.baseURL + '/api/Media/Tag?mediaID=' + mediaID + '&tagID=' + tagID, {
                            method: 'DELETE',
                            credentials: 'same-origin',
                            headers: this.headers
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok)
                            throw response;
                        if (response.ok) {
                            media = this.mediaCache[mediaID];
                            media.tags = _.filter(media.tags, function (tag) { return tag.tagID != tagID; });
                        }
                        return [2 /*return*/, response.ok];
                }
            });
        });
    };
    TCMediaManager.prototype.deleteImage = function (mediaID) {
        return __awaiter(this, void 0, void 0, function () {
            var response, orderIndex, count, i, monthCount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(this.baseURL + '/api/Photo/Delete/' + mediaID, {
                            method: 'DELETE',
                            credentials: 'same-origin',
                            headers: this.headers
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok)
                            throw response;
                        if (response.ok) {
                            // Remove image from cache
                            delete this.mediaCache[mediaID];
                            if (this.mediaOrder) {
                                orderIndex = this.mediaOrder.indexOf(mediaID);
                                if (orderIndex > -1) {
                                    this.mediaOrder.splice(orderIndex, 1);
                                    count = 0;
                                    for (i = 0; i < this.monthCounts.length; i++) {
                                        monthCount = this.monthCounts[i];
                                        count += monthCount.count;
                                        if (orderIndex < count) {
                                            monthCount.count--;
                                            if (monthCount.count <= 0) {
                                                this.monthCounts.splice(i, 1);
                                            }
                                            else {
                                                this.monthCounts[i] = monthCount;
                                            }
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        return [2 /*return*/, response.ok];
                }
            });
        });
    };
    TCMediaManager.prototype.bulkDeleteImage = function (mediaIDs) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(this.baseURL + '/api/photo/bulkdelete', {
                            method: 'DELETE',
                            credentials: 'same-origin',
                            headers: this.headers,
                            body: JSON.stringify(mediaIDs)
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok)
                            throw response;
                        if (response.ok) {
                            this.mediaCache = _.omit(this.mediaCache, mediaIDs);
                            this.refreshCache();
                        }
                        return [2 /*return*/, response.ok];
                }
            });
        });
    };
    TCMediaManager.prototype.bulkDeleteByFilter = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(this.baseURL + '/api/photo/bulkdeletebyfilter', {
                            method: 'DELETE',
                            credentials: 'same-origin',
                            headers: this.headers,
                            body: JSON.stringify(this.criteria)
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok)
                            throw response;
                        if (response.ok) {
                            this.mediaCache = {};
                            this.refreshCache();
                        }
                        return [2 /*return*/, response.ok];
                }
            });
        });
    };
    TCMediaManager.prototype.getThumbnails = function (indexStart, indexEnd) {
        return __awaiter(this, void 0, void 0, function () {
            var ids, media;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.mediaOrder == null) {
                            throw new Error('Cache is null must be initialized');
                        }
                        if (indexEnd > this.mediaOrder.length - 1)
                            indexEnd = this.mediaOrder.length - 1;
                        if (!!this.hasRange(indexStart, indexEnd)) return [3 /*break*/, 2];
                        // Page does not exist in cache, fetch from server
                        return [4 /*yield*/, this.fetchThumbnails(indexStart, indexEnd)];
                    case 1:
                        // Page does not exist in cache, fetch from server
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        ids = this.mediaOrder.slice(indexStart, indexEnd);
                        media = _.map(ids, function (mediaID) {
                            return _this.mediaCache[mediaID];
                        });
                        return [2 /*return*/, media];
                }
            });
        });
    };
    TCMediaManager.prototype.getThumbnailPage = function (index) {
        return __awaiter(this, void 0, void 0, function () {
            var pageSize, page, fetchStartIndex, fetchEndIndex, ids, media;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.mediaOrder == null) {
                            throw new Error('Cache is null must be initialized');
                        }
                        pageSize = this.internalPageSize;
                        page = Math.floor(index / pageSize);
                        fetchStartIndex = (page * pageSize);
                        fetchEndIndex = fetchStartIndex + pageSize - 1;
                        if (!!this.hasRange(fetchStartIndex, fetchEndIndex)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchThumbnails(fetchStartIndex, fetchEndIndex)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        ids = this.mediaOrder.slice(fetchStartIndex, fetchEndIndex + 1);
                        media = _.map(ids, function (mediaID) {
                            return _this.mediaCache[mediaID];
                        });
                        return [2 /*return*/, media];
                }
            });
        });
    };
    TCMediaManager.prototype.getAccountInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, results, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, fetch(this.baseURL + '/api/Media/AccountFilterInfo', {
                            credentials: 'same-origin',
                            headers: this.headers,
                        })];
                    case 1:
                        response = _c.sent();
                        if (!response.ok)
                            throw response;
                        _b = (_a = JSON).parse;
                        return [4 /*yield*/, response.text()];
                    case 2:
                        results = _b.apply(_a, [_c.sent()]);
                        this.cameraCache = results.cameras;
                        this.tagCache = results.tags;
                        return [2 /*return*/, results];
                }
            });
        });
    };
    TCMediaManager.prototype.getNextMediaID = function (currentID) {
        var currentIndex = _.indexOf(this.mediaOrder, currentID);
        if (currentIndex != -1 && currentIndex < this.mediaOrder.length - 1) {
            return this.mediaOrder[currentIndex + 1];
        }
        else {
            return null;
        }
    };
    TCMediaManager.prototype.getPreviousMediaID = function (currentID) {
        var currentIndex = _.indexOf(this.mediaOrder, currentID);
        if (currentIndex != -1 && currentIndex > 0) {
            return this.mediaOrder[currentIndex - 1];
        }
        else {
            return null;
        }
    };
    TCMediaManager.prototype.getMediaIndex = function (mediaID) {
        return _.indexOf(this.mediaOrder, mediaID);
    };
    TCMediaManager.prototype.getNextMedia = function (mediaID) {
        return __awaiter(this, void 0, void 0, function () {
            var currentIndex, nextIndex, totalMediaCount, nextMediaID, nextMediaID;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentIndex = this.getMediaIndex(mediaID);
                        nextIndex = currentIndex + 1;
                        return [4 /*yield*/, this.getTotalMediaCount()];
                    case 1:
                        totalMediaCount = _a.sent();
                        if (currentIndex == -1 || nextIndex == totalMediaCount) {
                            return [2 /*return*/, null];
                        }
                        if (!(nextIndex in this.mediaOrder)) return [3 /*break*/, 2];
                        nextMediaID = this.mediaOrder[nextIndex];
                        return [2 /*return*/, this.mediaCache[nextMediaID]];
                    case 2: return [4 /*yield*/, this.fetchThumbnails(nextIndex, nextIndex)];
                    case 3:
                        _a.sent();
                        if (nextIndex in this.mediaOrder) {
                            nextMediaID = this.mediaOrder[nextIndex];
                            return [2 /*return*/, this.mediaCache[nextMediaID]];
                        }
                        else {
                            console.log("Error getting next thumbnail index: " + nextIndex);
                            return [2 /*return*/, null];
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TCMediaManager.prototype.getPrevMedia = function (mediaID) {
        return __awaiter(this, void 0, void 0, function () {
            var currentIndex, prevIndex, prevMediaID, prevMediaID;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentIndex = this.getMediaIndex(mediaID);
                        prevIndex = currentIndex - 1;
                        if (currentIndex == -1 || prevIndex < 0) {
                            return [2 /*return*/, null];
                        }
                        if (!(prevIndex in this.mediaOrder)) return [3 /*break*/, 1];
                        prevMediaID = this.mediaOrder[prevIndex];
                        return [2 /*return*/, this.mediaCache[prevMediaID]];
                    case 1: return [4 /*yield*/, this.fetchThumbnails(prevIndex, prevIndex)];
                    case 2:
                        _a.sent();
                        if (prevIndex in this.mediaOrder) {
                            prevMediaID = this.mediaOrder[prevIndex];
                            return [2 /*return*/, this.mediaCache[prevMediaID]];
                        }
                        else {
                            console.log("Error getting prev thumbnail index: " + prevIndex);
                            return [2 /*return*/, null];
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TCMediaManager.prototype.fetchMediaCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, _a, _b, _c, totalCount;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, fetch(this.baseURL + '/api/Media/ThumbnailCountByMonth/', {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: this.headers,
                            body: JSON.stringify(this.criteria)
                        })];
                    case 1:
                        response = _d.sent();
                        if (!response.ok) {
                            throw response;
                        }
                        _a = this;
                        _c = (_b = JSON).parse;
                        return [4 /*yield*/, response.text()];
                    case 2:
                        _a.monthCounts = _c.apply(_b, [_d.sent()]);
                        totalCount = 0;
                        _.forEach(this.monthCounts, function (monthCount) {
                            totalCount += monthCount.count;
                        });
                        this.mediaOrder = new Array(totalCount);
                        if (this.mediaCache == null) {
                            this.mediaCache = {};
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TCMediaManager.prototype.hasRange = function (indexStart, indexEnd) {
        // Check if every image is present for given range
        var result = true;
        for (var i = indexStart; i <= indexEnd; i++) {
            if (!(i in this.mediaOrder)) {
                result = false;
                break;
            }
        }
        return result;
    };
    TCMediaManager.prototype.fetchThumbnails = function (indexStart, indexEnd) {
        var _this = this;
        // Find page containing indexStart
        var pageSize = this.internalPageSize;
        var page = Math.floor(indexStart / pageSize);
        // Find number of pages necessary to grab
        // Range could span multiple internal pages
        var fetchStartIndex = (page * pageSize);
        var pageCount = Math.ceil((indexEnd - fetchStartIndex) / pageSize);
        if (pageCount == 0 && indexStart == indexEnd) {
            pageCount = 1;
        }
        if (page in this.requestPromiseCache) {
            return this.requestPromiseCache[page];
        }
        var requestPromise = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var response, mediaArray, i, cacheIndex, mediaID, mediaObj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(this.baseURL + '/api/Media/Thumbnail?' + query.stringify({ page: page, pageSize: pageSize, pageCount: pageCount }), {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: this.headers,
                            body: JSON.stringify(this.criteria)
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok)
                            throw response;
                        return [4 /*yield*/, response.json()];
                    case 2:
                        mediaArray = _a.sent();
                        // Insert response array into proper spots in mediaCache
                        for (i = 0; i < mediaArray.length; i++) {
                            cacheIndex = fetchStartIndex + i;
                            mediaID = mediaArray[i].mediaID;
                            mediaObj = mediaArray[i];
                            this.mediaOrder[cacheIndex] = mediaID;
                            if (mediaID in this.mediaCache) {
                                _.assign(this.mediaCache[mediaID], mediaObj);
                            }
                            else {
                                this.mediaCache[mediaID] = mediaObj;
                            }
                        }
                        resolve(true);
                        return [2 /*return*/];
                }
            });
        }); });
        this.requestPromiseCache[page] = requestPromise;
        requestPromise.then(function () {
            delete _this.requestPromiseCache[page];
        });
        requestPromise.catch(function (ex) {
            delete _this.requestPromiseCache[page];
            throw ex;
        });
        return requestPromise;
    };
    return TCMediaManager;
}());
export { TCMediaManager };
export var mediaManagerInstance = new TCMediaManager();
//# sourceMappingURL=TCMediaManager.js.map